
export class NetworkStatus {

    constructor(protected online: boolean, protected authenticated: boolean) {

    }

    isOnline(): boolean {
        return this.online;
    }

    isAuthenticated(): boolean {
        return this.authenticated;
    }
}



// WEBPACK FOOTER //
// ./src/core/business-objects/network/network-status.ts